import React from 'react'
import type { ConversationType, InboxConversationDetail } from '../inboxTypes'
import { GeneralConversationContent } from './GeneralConversationContent'
import { IssueConversationContent } from './IssueConversationContent'
import { ReviewConversationContent } from './ReviewConversationContent'

export interface ConversationContentProps {
  conversation: InboxConversationDetail
  onActiveIssueClick?: () => void
  onIssueStatusChange?: () => void | Promise<void>
}

type ConversationContentComponent = React.FC<ConversationContentProps>

const conversationContentByType: Record<ConversationType, ConversationContentComponent> = {
  general: GeneralConversationContent,
  review: ReviewConversationContent,
  issue: IssueConversationContent
}

export const ConversationContent: React.FC<ConversationContentProps> = ({ conversation, onActiveIssueClick, onIssueStatusChange }) => {
  const ContentComponent = conversationContentByType[conversation.conversationType]

  return (
    <ContentComponent
      conversation={conversation}
      onActiveIssueClick={onActiveIssueClick}
      onIssueStatusChange={onIssueStatusChange}
    />
  )
}
